/* eslint-disable @typescript-eslint/no-magic-numbers */
import { BreakpointObserver } from '@angular/cdk/layout'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { environment } from 'src/environments/environment'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

import { PerformanceTabService } from './performance.service'

@Component({
  selector: 'performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.scss'],
})
export class PerformanceComponent implements OnInit, OnDestroy {
  perfomanceSubscription: Subscription
  performanceModel: any
  profileData: object

  pastPerformanceEtf: AEMChunk
  pastPerformanceMf: AEMChunk
  pastPerformance529: AEMChunk
  accountServiceFees: AEMChunk
  aemContentSub: Subscription
  isSmallScreen: boolean
  isLargeScreen: boolean

  expenseRatioFootnote: Footnote

  constructor(
    private readonly performanceService: PerformanceTabService,
    private readonly centralContentService: CentralContentService,
    public adobeLaunchService: AdobeLaunchService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.perfomanceSubscription = this.performanceService
      .getModelData()
      .subscribe((model) => {
        this.performanceModel = model
      })
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )

    this.breakpointObserver
      .observe(['(max-width: 576px)', '(max-width: 992px)'])
      .subscribe((result) => {
        this.isSmallScreen = result.breakpoints['(max-width: 576px)']
        this.isLargeScreen = result.breakpoints['(max-width: 992px)']
      })
  }

  parseAEMContent(content) {
    this.pastPerformanceEtf = this.centralContentService.getContentByBody(
      'disclaimer_past_performance_etf',
      content,
    )
    this.pastPerformanceMf = this.centralContentService.getContentByBody(
      'disclaimer_past_performance_mutualfund',
      content,
    )
    this.pastPerformance529 = this.centralContentService.getContentByBody(
      'disclaimer_past_performance_529',
      content,
    )
    this.accountServiceFees = this.centralContentService.getContentByBody(
      'disclaimer_performance_account_service_fee',
      content,
    )
  }
  isValidSinceInceptionHideChart(): boolean {
    let sinceInceptionAsOfDate =
      this.performanceModel?.performance?.monthEndAvgAnnualRtn
        ?.sinceInceptionAsOfDate
    if (!sinceInceptionAsOfDate) {
      return false
    }
    sinceInceptionAsOfDate = new Date(sinceInceptionAsOfDate)
    const minDate = new Date()
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    minDate.setFullYear(minDate.getFullYear() - 3)
    return minDate.getTime() >= sinceInceptionAsOfDate.getTime()
  }

  ngOnDestroy(): void {
    this.perfomanceSubscription.unsubscribe()
    this.aemContentSub.unsubscribe()
  }

  logAccordionValue(ev): void {
    if (ev.isExpanded) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.performanceModel?.profileData?.ticker}:Quarterly after-tax returns Accordion`,
      )
    }
  }

  onTabSelection(event: string) {
    if (this.performanceModel.profileData?.is529) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.performanceModel?.profileData?.fundId}:Total Returns:${event}`,
      )
    } else {
      this.adobeLaunchService.subPageTabEvent(
        `${this.performanceModel?.profileData?.ticker}:Total Returns:${event}`,
      )
    }
  }
}
